var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13M12 16H12.01M10.363 3.59095L2.25699 17.1249C2.08988 17.4143 2.00145 17.7424 2.0005 18.0766C1.99954 18.4108 2.08609 18.7393 2.25153 19.0297C2.41698 19.32 2.65555 19.562 2.94353 19.7315C3.2315 19.901 3.55884 19.9922 3.89299 19.9959H20.107C20.441 19.9921 20.7682 19.9009 21.056 19.7314C21.3438 19.562 21.5823 19.3201 21.7477 19.0299C21.9131 18.7397 21.9997 18.4113 21.9989 18.0773C21.9981 17.7433 21.9098 17.4153 21.743 17.1259L13.637 3.58994C13.4664 3.30845 13.2262 3.07569 12.9394 2.91414C12.6527 2.7526 12.3291 2.66772 12 2.66772C11.6709 2.66772 11.3473 2.7526 11.0605 2.91414C10.7738 3.07569 10.5335 3.30845 10.363 3.58994V3.59095Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.820f827c5aad8077ab090d0cc95b7d8e.svg";
export { ForwardRef as ReactComponent };